"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIsDomainInCart = exports.checkIfSearchCountVisible = exports.MarketHelper = void 0;
exports.getAuctionInfo = getAuctionInfo;
exports.shouldRenderMakeOfferModal = exports.renderAsPremium = exports.premiumDomainAvailableForBuyNow = exports.isTaken = exports.isSafariBrowser = exports.isRestricted = exports.isReseller = exports.isRegPremium = exports.isPreReg = exports.isBuyNowAuction = exports.isBrowser = exports.isAvailable = exports.isAuction = exports.isAftermarketPremium = exports.is123Reg = exports.getUserLoggedIn = exports.getSpinAvailabilityType = exports.getIsBrowserSupported = exports.getExactMatchAvailable = exports.getDomainTypes = exports.getDomainStatus = exports.getDomainMonthlyTerms = exports.getCookie = exports.getAvailLabel = void 0;
var _constants = require("./constants");
var _availabilityStatus = require("./constants/availabilityStatus");
var _availabilityLabel = require("./constants/availabilityLabel");
var _TccConstants = require("./constants/TccConstants");
var _searchStatus = require("./constants/searchStatus");
var _auctionTypes = require("./constants/auctionTypes");
/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint-disable complexity */

const NON_RESELLER_PLID = 1;
const RESELLER_123_REG_PLID = 587240;
const isAftermarketPremium = domain => {
  return domain.Inventory === _availabilityStatus.AvailabilityStatus.Premium;
};
exports.isAftermarketPremium = isAftermarketPremium;
const isRegPremium = domain => {
  return domain.Inventory === _availabilityStatus.AvailabilityStatus.RegPremium;
};
exports.isRegPremium = isRegPremium;
const isAuction = domain => {
  return domain.Inventory === _availabilityStatus.AvailabilityStatus.Auction;
};
exports.isAuction = isAuction;
const isRestricted = domain => {
  return Boolean(domain.IsRestricted);
};
exports.isRestricted = isRestricted;
const isPreReg = domain => {
  return domain.AvailabilityLabel === _availabilityStatus.AvailabilityStatus.PreReg;
};
exports.isPreReg = isPreReg;
const isTaken = domain => {
  return domain.AvailabilityLabel === _availabilityStatus.AvailabilityStatus.Taken;
};
exports.isTaken = isTaken;
const isAvailable = domain => {
  return domain.AvailabilityLabel === _availabilityStatus.AvailabilityStatus.Available;
};
exports.isAvailable = isAvailable;
const getAvailLabel = label => {
  switch (label) {
    case _availabilityStatus.AvailabilityStatus.Available:
      return _availabilityLabel.AVAILABILITY_LABEL.Available;
    case _availabilityStatus.AvailabilityStatus.PreReg:
      return _availabilityLabel.AVAILABILITY_LABEL.PreReg;
    case _availabilityStatus.AvailabilityStatus.Premium:
    case _availabilityStatus.AvailabilityStatus.RegPremium:
    case _availabilityStatus.AvailabilityStatus.Auction:
      return _availabilityLabel.AVAILABILITY_LABEL.Premium;
    case _availabilityStatus.AvailabilityStatus.Taken:
    case _availabilityStatus.AvailabilityStatus.Excluded:
    case _availabilityStatus.AvailabilityStatus.Reserved:
      return _availabilityLabel.AVAILABILITY_LABEL.Taken;
    default:
      return _availabilityLabel.AVAILABILITY_LABEL.Error;
  }
};
exports.getAvailLabel = getAvailLabel;
const getDomainStatus = ({
  isAftermarketPremiumDomain,
  isAuctionDomain,
  isRegPremiumDomain
}) => {
  if (isAftermarketPremiumDomain) {
    return 'premium';
  }
  if (isAuctionDomain) {
    return 'auction';
  }
  if (isRegPremiumDomain) {
    return 'registry_premium';
  }
  return 'available_for_registration';
};
exports.getDomainStatus = getDomainStatus;
const renderAsPremium = domain => {
  return isAftermarketPremium(domain) || isRegPremium(domain) || isAuction(domain);
};
exports.renderAsPremium = renderAsPremium;
const isReseller = plid => {
  return plid && plid.toString() !== NON_RESELLER_PLID.toString();
};
exports.isReseller = isReseller;
const is123Reg = plid => {
  return plid && plid.toString() === RESELLER_123_REG_PLID.toString();
};
exports.is123Reg = is123Reg;
const MarketHelper = exports.MarketHelper = {
  isPhoneHiddenMarket(market) {
    return market === 'zh-SG';
  },
  marketDir() {
    return window.ux?.eldorado?.data?.dir || 'ltr';
  },
  isRtlMarket() {
    return this.marketDir() === 'rtl';
  }
};
const getDomainTypes = domain => ({
  isAftermarketPremium: isAftermarketPremium(domain),
  isRegPremium: isRegPremium(domain),
  isAuction: isAuction(domain),
  renderAsPremium: renderAsPremium(domain)
});
exports.getDomainTypes = getDomainTypes;
const isBrowser = () => {
  return !!(typeof window !== 'undefined' && typeof document !== 'undefined');
};
exports.isBrowser = isBrowser;
const getCookie = name => {
  // check if it's browser or server side. Must do this tertiary or the variable gets hoisted above the if check.
  const match = isBrowser() ? document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)')) : false;
  return match ? match[2] : '';
};

/**
 * @description Returns spin availability Type.
 * @param {object} spin spin object.
 * @returns {string} availability type
 */
exports.getCookie = getCookie;
const getSpinAvailabilityType = spin => {
  if (isAftermarketPremium(spin) || isAuction(spin)) {
    return _TccConstants.AVAILABILITY_TYPES.availableAftermarketPremium;
  } else if (isRegPremium(spin)) {
    return _TccConstants.AVAILABILITY_TYPES.availablePrimaryRegPremiumTier;
  }
  return _TccConstants.AVAILABILITY_TYPES.availablePrimaryBaseTier;
};
exports.getSpinAvailabilityType = getSpinAvailabilityType;
const isSafariBrowser = () => {
  return window?.navigator?.userAgent?.indexOf('Safari') > -1 && window?.navigator?.userAgent?.indexOf('Chrome') <= -1;
};

/**
 * @description Determines whether the browser being used is included in the list you provide of supported browsers
 * @param {Array<String>} supportedBrowsers array of strings.
 * Example for supportedBrowsers prop: ['chrome', 'safari', 'edge', 'samsung']
 * @returns {Boolean}
 */
exports.isSafariBrowser = isSafariBrowser;
const getIsBrowserSupported = supportedBrowsers => {
  if (!window || !window?.navigator?.userAgent) {
    return false;
  }
  const userAgent = window?.navigator?.userAgent?.toLowerCase();
  const isSupported = supportedBrowsers.map(browser => userAgent.includes(browser.toLowerCase()));
  return isSupported.includes(true);
};
exports.getIsBrowserSupported = getIsBrowserSupported;
const getUserLoggedIn = isUserLoggedIn => {
  if (!isUserLoggedIn) {
    const idpData = JSON.parse(window.decodeURIComponent(getCookie('info_idp')) || '{}');
    const mergedIdpData = {
      ...idpData,
      ...(idpData?.[idpData.auth] || {})
    };
    const {
      info_shopperId = ''
    } = mergedIdpData;
    return !!info_shopperId;
  }
  return isUserLoggedIn;
};

/**
 * @description Determines monthly terms to use for a product based on term overrides and other term length configurations
 * @param {object} product product that includes domain info
 * @param {object} product.domain domain info
 * @param {object} product.priceInfo product's price info
 * @param {Array<Number>} product.priceInfo.SupportedYears array of supported years for term length
 * @param {number} product.priceInfo.PromoRegLengthFlag PromoRegLengthFlag value
 * @param {number} tmskeyTerms [optional] Term length configured via tmskey config (in months).
 * @param {boolean} isUserLoggedIn [optional] is it new or repeat shopper
 * @param {number} domainTermsOverride [optional] term length override (in months). It is any term override that should take priority over any other term configuration
 * @param {number} defaultDomainTerms [optional] default term length configuration (in months). Term to use by default
 * @returns {{Fqdn: string, term: number}} domain and monthly term to use
 */
exports.getUserLoggedIn = getUserLoggedIn;
const getDomainMonthlyTerms = ({
  product = {},
  tmskeyTerms,
  isUserLoggedIn,
  domainTermsOverride,
  defaultDomainTerms,
  skipSupportedYearsCheck
} = {}) => {
  const {
    domain,
    priceInfo = {}
  } = product;
  const supportedYears = priceInfo.SupportedYears;
  const promoRegLengthTerms = priceInfo.PromoRegLengthFlag > 1 && priceInfo.PromoRegLengthFlag * 12;
  let domainMonthlyTerms = domainTermsOverride || tmskeyTerms || promoRegLengthTerms || defaultDomainTerms;
  const bypassSupportedYearsCheck = tmskeyTerms && domainMonthlyTerms === tmskeyTerms || !supportedYears?.length || skipSupportedYearsCheck;
  if (!domainMonthlyTerms) {
    domainMonthlyTerms = getUserLoggedIn(isUserLoggedIn) ? _constants.REPEAT_USER_MONTHLY_TERM : _constants.NEW_USER_MONTHLY_TERM;
  }
  if (!bypassSupportedYearsCheck && supportedYears.findIndex(year => year === domainMonthlyTerms / 12) === -1) {
    domainMonthlyTerms = Math.min(...supportedYears) * 12;
  }
  return {
    Fqdn: domain?.Fqdn,
    term: domainMonthlyTerms
  };
};
exports.getDomainMonthlyTerms = getDomainMonthlyTerms;
function getAuctionInfo(auctionTypeId, auctionTypeIdsStraightToCart = []) {
  const addStraightToCart = auctionTypeIdsStraightToCart.includes(auctionTypeId);
  // For all ids, refer to https://godaddy-corp.atlassian.net/wiki/spaces/AN/pages/83559972/Aftermarket+Business+Requirements
  if (_auctionTypes.AuctionTypes.Biddable.includes(auctionTypeId)) {
    return {
      infoTextId: 'domain.available.info.bid',
      buyNowTextId: 'bid',
      showMakeOffer: !addStraightToCart,
      makeOfferTextId: 'placeBid'
    };
  } else if (_auctionTypes.AuctionTypes.BuyItNowOfferCounterOffer.includes(auctionTypeId)) {
    return {
      infoTextId: 'domain.available.info.getIt',
      buyNowTextId: 'getIt',
      showMakeOffer: !addStraightToCart,
      makeOfferTextId: 'getIt'
    };
  } else if (_auctionTypes.AuctionTypes.BuyItNowNonCloseout.includes(auctionTypeId)) {
    return {
      infoTextId: 'domain.available.info.buyItNow',
      buyNowTextId: 'buyItNow',
      showMakeOffer: false
    };
  } else if (_auctionTypes.AuctionTypes.MemberOfferCounterOffer.includes(auctionTypeId)) {
    return {
      infoTextId: 'domain.available.info.makeOffer',
      buyNowTextId: 'makeOffer',
      showMakeOffer: !addStraightToCart,
      makeOfferTextId: 'makeOffer'
    };
  }
  return {};
}
const isBuyNowAuction = domain => {
  const id = domain?.AuctionTypeId || 0;
  return _auctionTypes.AuctionTypes.BuyItNowNonCloseout.includes(id);
};

/**
 * Determines if a domain should render the MakeOfferModal
 * @param {Object} domain - The domain object
 * @returns {boolean} - True if domain should show MakeOfferModal
 */
exports.isBuyNowAuction = isBuyNowAuction;
const shouldRenderMakeOfferModal = domain => {
  if (!domain) return false;

  // Check for auction domains with type 33 ONLY (MemberOfferCounterOffer)
  const isAuctionType33 = isAuction(domain) && domain.AuctionTypeId === 33;

  // Check for premium domains (aftermarket or registry premium) and unpriced aftermarket domains
  const isPremiumUnpricedDomain = isAftermarketPremium(domain) && Boolean(domain.IsUnpricedAftermarketDomain);
  return isAuctionType33 || isPremiumUnpricedDomain;
};
exports.shouldRenderMakeOfferModal = shouldRenderMakeOfferModal;
const premiumDomainAvailableForBuyNow = domain => {
  const isDomainAftermarketPremium = isAftermarketPremium(domain);
  const isDomainRegPremium = isRegPremium(domain);
  const isDomainAuction = isAuction(domain);
  return isDomainAftermarketPremium || isDomainRegPremium || isDomainAuction && isBuyNowAuction(domain);
};

// eslint-disable-next-line max-statements
exports.premiumDomainAvailableForBuyNow = premiumDomainAvailableForBuyNow;
const getExactMatchAvailable = (exactResult, exactResultProduct, smartExactResult) => {
  const exactMatchDomain = exactResult;
  const priceInfo = exactResultProduct.PriceInfo;
  const product = exactResultProduct;
  const productContent = exactResultProduct.Content;
  const smartExactMatchDomain = smartExactResult?.ExactMatchDomain;
  const smartPriceInfo = smartExactResult?.Products?.[0]?.PriceInfo;
  const smartProduct = smartExactResult?.Products?.[0];

  // getAvailLabel can group several domain labels into one (ie premium, regpremium, auction = premium)
  const exactMatchAvailability = getAvailLabel(exactMatchDomain?.AvailabilityLabel);
  const isExactMatchDomainAvailable = exactMatchAvailability === _searchStatus.SEARCH_STATUS.Available;
  const isExactMatchDomainTaken = exactMatchAvailability === _searchStatus.SEARCH_STATUS.Taken;
  const isAftermarketPremiumDomain = isAftermarketPremium(exactMatchDomain);
  const isRegPremiumDomain = isRegPremium(exactMatchDomain);
  const isAuctionDomain = isAuction(exactMatchDomain);
  const isPreRegDomain = isPreReg(exactMatchDomain);
  const isSmartExactMatchDomainAvailable = getAvailLabel(smartExactMatchDomain?.AvailabilityLabel) === _searchStatus.SEARCH_STATUS.Available;
  const showSmartExactMatchDomain = !isExactMatchDomainAvailable && isExactMatchDomainTaken && isSmartExactMatchDomainAvailable;
  return {
    showSmartExactMatchDomain,
    isAvailable: isExactMatchDomainAvailable,
    isTaken: isExactMatchDomainTaken,
    isAftermarketPremium: isAftermarketPremiumDomain,
    isRegPremium: isRegPremiumDomain,
    isAuction: isAuctionDomain,
    isPreReg: isPreRegDomain,
    exactMatchDomain: showSmartExactMatchDomain ? smartExactMatchDomain : exactMatchDomain,
    priceInfo: showSmartExactMatchDomain ? smartPriceInfo : priceInfo,
    product: showSmartExactMatchDomain ? smartProduct : product,
    productContent,
    renderAsPremium: isAftermarketPremiumDomain || isAuctionDomain || isRegPremiumDomain
  };
};
exports.getExactMatchAvailable = getExactMatchAvailable;
const checkIfSearchCountVisible = ({
  showSearchCount,
  uniqueSearchCount,
  searchCountThreshold
}) => {
  return !!(showSearchCount && uniqueSearchCount >= searchCountThreshold && uniqueSearchCount > 0);
};

/**
 * @description Determines if a domain is already in the cart by checking if its Fqdn matches any cart item's Fqdn
 * @param {Array} cartContents - Array of cart items
 * @param {Object} domain - Domain object with Fqdn property
 * @returns {boolean} - True if domain is in cart, false otherwise
 */
exports.checkIfSearchCountVisible = checkIfSearchCountVisible;
const checkIsDomainInCart = (cartContents, domain) => {
  return Array.from(cartContents || []).some(cartItem => cartItem.Fqdn === domain?.Fqdn);
};
exports.checkIsDomainInCart = checkIsDomainInCart;